/**
 * Ryan O'Dowd
 * 2018-05-28
 * © Copyright 2018 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, safeAreaInsets}) => {
  return {
    container: {
      flexGrow: 1,
      justifyContent: 'space-around',
      alignItems: 'center',
    },
    innerContainer: {
      flex: 1,
      width: globalScale * 300,
      justifyContent: 'space-around',
      marginBottom: safeAreaInsets.bottom,
    },
    loginContainer: {
      flex: 1,
      justifyContent: 'center',
      alignSelf: 'center',
    },
    buttonsWrapper: {
      justifyContent: 'center',
      alignItems: 'center',
    },

    brandingContainer: {
      justifyContent: 'center',
      alignItems: 'center',
    },
    appName: {
      fontSize: globalScale * 42,
      fontFamily: fonts.secondaryBold,
      color: colors.white,
    },
    linkInstructions: {
      fontSize: globalScale * 16,
      marginTop: globalScale * 16,
      textAlign: 'center',
      padding: globalScale * 32,
      color: colors.white,
    },
    logoBackground: {
      width: globalScale * 68,
      height: globalScale * 68,
      margin: globalScale * 10,
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: globalScale * 34,
      overflow: 'hidden',
    },
    logo: {
      width: globalScale * 68,
      height: globalScale * 68,
    },
    lowerContentWrapper: {
      justifyContent: 'center',
      alignItems: 'center',
      // @TODO: padding: globalScale * 40,
      paddingTop: 0,
      paddingBottom: globalScale * 60,
    },
    disclaimerWrapper: {
      width: '100%',
      justifyContent: 'flex-end',
      alignItems: 'center',
      padding: globalScale * 16,
      marginBottom: globalScale * 16,
    },
    disclaimerText: {
      fontSize: globalScale * 12,
      textAlign: 'center',
      color: colors.white,
    },
    disclaimerLink: {
      fontFamily: fonts.secondary, // @TODO: should be bold?
    },

    welcomeContainer: {
      flex: 1,
      gap: 60,
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    welcomeHeaderText: {
      fontSize: globalScale * 20,
      fontFamily: fonts.secondary, // @TODO: should be bold?
      textAlign: 'center',
      color: colors.white,
    },
    verse: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    verseText: {
      marginTop: globalScale * 12,
      fontSize: globalScale * 15,
      textAlign: 'center',
      color: colors.white,
    },
    authPaperButton: {
      color: colors.black,
    },

    submitButton: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

  };
};

export default getStyles;
